<template>
  <div>
    <div v-if="!swiperDay" class="step-dynamic__loader">
      <Loader size="24" />
    </div>
    <div v-show="swiperDay" class="swiper-container" ref="dailySwiper">
      <div class="swiper-wrapper">
        <div
          v-for="(day, index) in daysData"
          :key="index"
          class="swiper-slide"
          :class="{ 'hidden-slide': isSlideHidden }"
        >
          <ProgressBarNew
            :date="day.date"
            :value="day.stepsCount || 0"
            :targetSteps="day.targetCount || 0"
          />
        </div>
      </div>
      <Button :disabled="!canSlidePrev" class="swiper-button-prev day-button" variant="clear" shape="circle" size="lg" iconLeft="left" />
      <Button :disabled="!canSlideNext" class="swiper-button-next day-button" variant="clear" shape="circle" size="lg" iconLeft="right" />
    </div>
    <!-- Информация о днях -->
    <div class="step-dynamic__items">
      <div class="step-dynamic__item">
        <Icon name="walking" size="xl" />
        <div>
          <span class="step-dynamic__item-value">{{ currentDayData.kilometers }}</span>
          <span class="step-dynamic__item-unit">км</span>
        </div>
      </div>

      <div class="step-dynamic__item step-dynamic__item_position" @click="$emit('goRating')">
        <Icon name="trophy" size="xl" />
        <div>
          <span class="step-dynamic__item-unit">№</span>
          <span class="step-dynamic__item-value">{{ currentDayData.position }}</span>
        </div>
      </div>

      <div class="step-dynamic__item">
        <img :src="coinImg" />
        <span class="step-dynamic__item-value">{{ currentDayData.points }}</span>
      </div>
    </div>

    <div class="step-dynamic__target-wrapper">
      <div @click="chageTarget" v-if="isCurrentDay" class="step-dynamic__target">
        <Icon name="empty-flag" size="xl" />
        <span>Изменить цель шагов</span>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';
import CoinImg from '@/assets/img/coin.svg';
import ProgressBarNew from '../ProgressBarCircle/ProgressBarNew.vue';
import 'swiper/swiper-bundle.css';

export default {
  name: 'DailyTab',
  components: {
    ProgressBarNew,
  },
  data() {
    return {
      daysData: [],
      swiperDay: null,
      isSlideHidden: false,
      coinImg: CoinImg,
      activeIndex: 1,
    };
  },
  computed: {
    ...mapGetters('steps', ['stepsHistory', 'participantPositionData']),
    ...mapGetters('user', ['profile']),
    currentDayData() {
      return this.daysData[1] || {};
    },
    canSlideNext() {
      if (!this.daysData.length || this.activeIndex == null) return false;
      const todayStr = dayjs().format('YYYY-MM-DD');
      const currentDate = this.daysData[this.activeIndex].date;
      return currentDate !== todayStr;
    },
    canSlidePrev() {
      if (!this.daysData.length || this.activeIndex == null) return true;
      if (!this.profile || !this.profile.createdOn) return true;

      const userCreatedDate = dayjs(this.profile.createdOn).format('YYYY-MM-DD');
      const currentDate = this.daysData[this.activeIndex].date;

      // Разрешаем свайп влево, если текущая дата не совпадает с датой регистрации
      return currentDate !== userCreatedDate;
    },
    isCurrentDay() {
      if (!this.daysData.length || this.activeIndex == null) return false;
      const todayStr = dayjs().format('YYYY-MM-DD');
      const currentDate = this.daysData[this.activeIndex].date;
      return currentDate === todayStr;
    },
    centralDay() {
      return this.daysData && this.daysData[1] ? this.daysData[1] : {};
    },
  },
  methods: {
    ...mapActions('steps', ['getStepsHistory', 'getParticipantPositionData']),

    chageTarget() {
      this.$emit('changeTarget');
    },

    updateSwiperLock() {
      if (!this.swiperDay || !this.daysData.length || !this.profile?.createdOn) return;

      const userCreatedStr = dayjs(this.profile.createdOn).format('YYYY-MM-DD');
      const todayStr = dayjs().format('YYYY-MM-DD');
      const currentDate = this.daysData[this.activeIndex]?.date;

      this.swiperDay.allowSlidePrev = currentDate !== userCreatedStr;
      this.swiperDay.allowSlideNext = currentDate !== todayStr;
    },

    async fetchDayData(date) {
      const [positionData, stepsData] = await Promise.all([
        this.getParticipantPositionData({ dateFrom: date, periodType: 'daily' }),
        this.getStepsHistory({ dateFrom: date, dateTo: date, periodType: 'daily' }),
      ]);

      if (!stepsData || stepsData.length === 0 || !positionData) {
        return {
          date,
          stepsCount: 0,
          targetCount: 0,
          position: 0,
          points: 0,
          kilometers: 0,
        };
      }

      const item = (stepsData || []).find((d) => d.date === date) || {};

      return {
        date,
        stepsCount: item.stepsCount || 0,
        targetCount: item.targetCount || 0,
        position: positionData?.position,
        points: positionData?.accruedPoints,
        kilometers: positionData?.kilometers,
      };
    },
    async refreshSwiper() {
      this.$nextTick(() => {
        if (this.$refs.dailySwiper && this.$refs.dailySwiper.querySelectorAll('.swiper-slide').length > 0) {
          this.swiperDay.update();
          this.swiperDay.slideTo(1, 0);
        }
      });
    },
    async setInitialDays() {
      const today = dayjs();
      const dates = [
        today.subtract(1, 'day'),
        today,
        today.add(1, 'day'),
      ].map((d) => d.format('YYYY-MM-DD'));

      const [prev, curr, next] = await Promise.all(
        dates.map((date) => this.fetchDayData(date)),
      );

      this.daysData = [prev, curr, next];

      this.$nextTick(() => {
        this.initSwiper();
        this.refreshSwiper(); // <--- вот он, гарантированный переход на центр
        this.updateSwiperLock();
      });
    },

    async handleSlideChange() {
      if (!this.swiperDay) return;
      const { realIndex } = this.swiperDay;
      this.isSlideHidden = true;

      if (realIndex === 0) {
        const newDate = dayjs(this.daysData[0].date).subtract(1, 'day').format('YYYY-MM-DD');
        const newData = await this.fetchDayData(newDate);
        this.daysData = [newData, ...this.daysData.slice(0, 2)];
      } else if (realIndex === 2) {
        const newDate = dayjs(this.daysData[2].date).add(1, 'day').format('YYYY-MM-DD');
        const newData = await this.fetchDayData(newDate);
        this.daysData = [...this.daysData.slice(1), newData];
      }

      // Обновляем активный индекс
      this.activeIndex = this.swiperDay.realIndex;

      // После изменения слайда проверяем блокировку свайпа
      this.$nextTick(() => {
        this.updateSwiperLock();
        if (this.swiperDay) {
          this.swiperDay.slideTo(1, 0); // Переход на центральный слайд
        }
        setTimeout(() => {
          this.isSlideHidden = false;
        }, 250);
      });
    },

    initSwiper() {
      this.swiperDay = new Swiper(this.$refs.dailySwiper, {
        slidesPerView: 1,
        spaceBetween: 0,
        allowTouchMove: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        initialSlide: 1,
        on: {
          slideChange: this.handleSlideChange,
        },
      });
    },
  },

  mounted() {
    this.setInitialDays();
  },
};
</script>

<style lang="scss" scoped>
@import './StepDynamicModal';

.step-dynamic__loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 296px;
}
.swiper-slide {
  height: 296px;
}
.hidden-slide {
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}
  .swiper-button-next,
  .swiper-button-prev {
    flex: 0 0 auto;
    width: 48px;
    height: 48px;
    background: $color-white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 1px 1px rgba(0, 0, 0, 0.08);
    border-radius: 50% !important;
    outline: none;
    position: absolute;
    line-height: 1;
    z-index: 2;
    transition: 0.2s ease-in-out;
    color: $color-black-85;

    &:hover {
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08);
    }

    svg {
      fill: currentColor;
    }

    @media (max-width: 866px) {
      margin-left: 0;
      margin-right: 0;
    }
  }
  ::v-deep .swiper-button-next.disabled,
  ::v-deep .swiper-button-prev.disabled {
    box-shadow: none;
  }
  .day-button.disabled {
    opacity: 0;
  }
  .day-button {
    @media (max-width: 866px) {
      display: none;
    }
  }
</style>
